"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableRow = exports.StyledTableHead = exports.StyledTableCell = exports.StyledTable = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var StyledTable = exports.StyledTable = _styledComponents.default.table.withConfig({
  displayName: "Tablestyled__StyledTable",
  componentId: "sc-7uq2mb-0"
})(["border-collapse:collapse;"]);
var StyledTableRow = exports.StyledTableRow = _styledComponents.default.tr.withConfig({
  displayName: "Tablestyled__StyledTableRow",
  componentId: "sc-7uq2mb-1"
})(["", " ", " &[aria-selected='true']{background-color:", ";}", " ", ""], function (_ref) {
  var header = _ref.header,
    lastRow = _ref.lastRow;
  return !header && !lastRow && (0, _styledComponents.css)(["border-bottom:", " solid ", ";"], _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative);
}, function (_ref2) {
  var hasVerticalStrokes = _ref2.hasVerticalStrokes,
    header = _ref2.header;
  return hasVerticalStrokes && (0, _styledComponents.css)(["> *:not(:first-child)", "{border-left:", " solid ", ";}"], header && ':not(:empty)', _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative);
}, _tokens.default.sky.comp.table.color.background.defaultcell.selected, function (_ref3) {
  var header = _ref3.header,
    footer = _ref3.footer;
  return !header && !footer && (0, _styledComponents.css)([":hover{background-color:", ";}"], _tokens.default.sky.comp.table.color.background.defaultcell.hover);
}, function (_ref4) {
  var footer = _ref4.footer;
  return footer && (0, _styledComponents.css)(["background-color:", ";:hover{background-color:", ";}"], _tokens.default.sky.comp.table.color.background.totalcell.default, _tokens.default.sky.comp.table.color.background.totalcell.hover);
});
var commonCellStyling = function commonCellStyling(_ref5) {
  var header = _ref5.header,
    width = _ref5.width,
    stickyHeader = _ref5.stickyHeader;
  return (0, _styledComponents.css)(["padding:0 ", ";", " ", ";", ";", ";"], _tokens.default.sky.sys.spacing["200"], width ? (0, _styledComponents.css)(["width:", ";"], width) : undefined, stickyHeader && (0, _styledComponents.css)(["background-color:", ";position:sticky;top:0;"], _tokens.default.sky.sys.color.background.neutral['1']), header && (0, _styledComponents.css)(["box-shadow:inset 0 -", " ", ";"], _tokens.default.sky.sys.size.borderwidth.thin, _tokens.default.sky.sys.color.border.decorative), header ? _tokens.default.sky.comp.table.cell.font.bold : _tokens.default.sky.sys.font.body["2"]);
};
var StyledTableCell = exports.StyledTableCell = _styledComponents.default.td.withConfig({
  displayName: "Tablestyled__StyledTableCell",
  componentId: "sc-7uq2mb-2"
})(["", ""], commonCellStyling);
var StyledTableHead = exports.StyledTableHead = _styledComponents.default.th.withConfig({
  displayName: "Tablestyled__StyledTableHead",
  componentId: "sc-7uq2mb-3"
})(["", ""], commonCellStyling);